export type ScannedString = { argIndex: number; start: number; end: number; value: string };

export type ScannedCall = {
  name: string | null;
  openParen: number;
  end: number;
  closed: boolean;
  argStarts: number[];
  strings: ScannedString[];
};

export function scanCalls(text: string): ScannedCall[] {
  if (!text.startsWith("=")) return [];
  const calls: ScannedCall[] = [];
  const stack: ScannedCall[] = [];
  let wordStart = -1;
  for (let i = 1; i < text.length; i++) {
    const c = text[i]!;
    if (/[A-Za-z]/.test(c)) {
      if (wordStart < 0) wordStart = i;
      continue;
    }
    const word = wordStart >= 0 ? text.slice(wordStart, i) : null;
    wordStart = -1;
    if (c === '"') {
      let j = i + 1;
      while (j < text.length && text[j] !== '"') j++;
      const end = j < text.length ? j + 1 : text.length;
      const top = stack[stack.length - 1];
      if (top) top.strings.push({ argIndex: top.argStarts.length - 1, start: i, end, value: text.slice(i + 1, j) });
      i = end - 1;
    } else if (c === "(") {
      const call: ScannedCall = {
        name: word,
        openParen: i,
        end: text.length,
        closed: false,
        argStarts: [i + 1],
        strings: [],
      };
      stack.push(call);
      calls.push(call);
    } else if (c === ")") {
      const call = stack.pop();
      if (call) {
        call.end = i + 1;
        call.closed = true;
      }
    } else if (c === ",") {
      const top = stack[stack.length - 1];
      if (top) top.argStarts.push(i + 1);
    }
  }
  return calls;
}

export function innermostCallAt(calls: ScannedCall[], caret: number): ScannedCall | null {
  let best: ScannedCall | null = null;
  for (const call of calls) {
    const inside = caret > call.openParen && (call.closed ? caret < call.end : caret <= call.end);
    if (inside && (!best || call.openParen > best.openParen)) best = call;
  }
  return best;
}
